import React, { Component, createContext, ReactNode, useContext } from 'react';
import { SerendieProvider } from '@serendie/ui';
import { Components } from '../../Components';
import { LanguageOptions } from '@iconics/localisation';

export const ComponentsContext = createContext<Components | undefined>(undefined);

export interface ComponentsProviderProps
{
    components: Components;
    language?: LanguageOptions;
    children?: ReactNode;
}

export class ComponentsProvider extends Component<ComponentsProviderProps>
{
    public render(): React.ReactNode
    {
        const { children, components } = this.props;

        const lang = this.props.language?.current === 'ja' ? 'ja' : 'en';

        return (
            <ComponentsContext.Provider value={components}>
                <SerendieProvider lang={lang}>
                    {children}
                </SerendieProvider>
            </ComponentsContext.Provider>
        );
    }
}

export function useComponents(): Components
{
    const context = useContext(ComponentsContext);
    if (!context)
    {
        throw new Error('useComponents must be used within a ComponentsProvider');
    }
    return context;
}

export function withComponents<P extends { components: Components }>(
    WrappedComponent: React.ComponentType<P>
)
{
    return (props: Omit<P, 'components'>) =>
    {
        const components = useComponents();
        return <WrappedComponent {...(props as P)} components={components} />;
    };
}
export default ComponentsProvider;